// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Gy-tQ","text":"SelectPayment_text__2K0wQ","title":"SelectPayment_title__1m1HE","btn":"SelectPayment_btn__1EZYb"};